module.exports = __webpack_public_path__ + "d3a56617dcbb6cf21bc4d1052103b405.png";